import { getFontSizeConfigData } from '../../../editor/src/js/constants/toolbar-data';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import { FontSizeBoundaryVal } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/font-size';

export const getFontSizeConfigDataContent = () => {
    const contents: string[] = [];
    getFontSizeConfigData().forEach((itemData) => {
        const { content } = itemData;
        contents.push(content);
    });
    return contents;
};

// 判断单双栏的字号大小
export const getFontSizeFromDataItems = (items) => {
    if (!items || items.length < 1) return '';
    // 双栏的数据
    if (items[0].top || items[0].big) {
        let fontSize = null;
        items.forEach((item) => {
            if (item.big) {
                item.big.forEach((i) => {
                    if (i.id === ActionType.FONTSIZE) fontSize = i.value;
                });
            }
            if (item.top) {
                item.top.forEach((i) => {
                    if (i.id === ActionType.FONTSIZE) fontSize = i.value;
                });
                item.bottom.forEach((i) => {
                    if (i.id === ActionType.FONTSIZE) fontSize = i.value;
                });
            }
        });
        return fontSize;
    }
    const fontSizeItem = items.filter(item => item.id === ActionType.FONTSIZE);
    if (fontSizeItem.length !== 1) return '';
    return fontSizeItem[0].value;
};

export const getFontSizeNextIndexInContents = (curSize, type: string) => {
    const contents = getFontSizeConfigDataContent();
    let index = contents.indexOf(curSize);
    if (index === -1) {
        index = contents.findIndex(item => Number(item) - curSize > 0);
        if (type === ActionType.FONTSIZE_DOWN) {
            index -= 1;
        }
    } else {
        if (type === ActionType.FONTSIZE_UP) {
            index += 1;
        } else {
            index -= 1;
        }
    }
    return index;
};

function getQuickSetFontSize(items: string|Array<any>, type: string): number {
    let fontSize;
    if (typeof items === 'string') {
        fontSize = items;
    } else {
        fontSize = getFontSizeFromDataItems(items);
    }
    const num = fontSize.match(/-([\d|.]*)\+?pt/);
    if (!num) return 0;
    const [, curSize] = num;
    const contents = getFontSizeConfigDataContent();
    let nextIndex;
    if (curSize - FontSizeBoundaryVal.FONT_SIZE_MAX > 0) {
        nextIndex = contents.length - 1;
    } else if (curSize - FontSizeBoundaryVal.FONT_SIZE_MIN < 0) {
        nextIndex = 0;
    } else {
        nextIndex = getFontSizeNextIndexInContents(curSize, type);
    }
    if (nextIndex === -1) return FontSizeBoundaryVal.FONT_CHANGE_DIFF;
    const sizeDiff = Math.abs(Number(contents[nextIndex]) - curSize);
    return sizeDiff;
}

export { getQuickSetFontSize };

